import { useStoreActions } from '~/contexts';
import { useMutationState } from '../useMutationState';
export const useSubmitServiceDescriptionFeedback = ()=>{
    const { api } = useStoreActions();
    const { mutateAsync, isPending } = useMutationState({
        mutationFn: async (param)=>{
            let { conversationId, data } = param;
            return api.service.submitServiceDescriptionFeedback(conversationId, data);
        },
        withPageLoader: false
    });
    return {
        submitFeedback: mutateAsync,
        isLoading: isPending
    };
};
